/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Check,
  CheckInput,
  SchemaValidationErrorResponse,
  StandardError,
  Vehicle,
  VehicleCreateBulkInput,
  VehicleCreateInput,
  VehicleDestroyBulkInput,
  VehicleUpdateBulkInput,
  VehicleUpdateInput
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create new Vehicle
 */
export const createVehicle = (
    vehicleCreateInput: MaybeRefOrGetter<VehicleCreateInput>,
 signal?: AbortSignal
) => {
      vehicleCreateInput = toValue(vehicleCreateInput);

      return axiosClient<Vehicle>(
      {url: `/vehicles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleCreateInput, signal
    },
      );
    }




export const getCreateVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicle>>, TError,{data: VehicleCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVehicle>>, TError,{data: VehicleCreateInput}, TContext> => {

const mutationKey = ['createVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVehicle>>, {data: VehicleCreateInput}> = (props) => {
          const {data} = props ?? {};

          return  createVehicle(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof createVehicle>>>
    export type CreateVehicleMutationBody = VehicleCreateInput
    export type CreateVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create new Vehicle
 */
export const useCreateVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicle>>, TError,{data: VehicleCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVehicle>>,
        TError,
        {data: VehicleCreateInput},
        TContext
      > => {
      return useMutation(getCreateVehicleMutationOptions(options), queryClient);
    }
    /**
 * @summary Create multiple vehicles
 */
export const createBulkVehicle = (
    vehicleCreateBulkInput: MaybeRefOrGetter<VehicleCreateBulkInput>,
 signal?: AbortSignal
) => {
      vehicleCreateBulkInput = toValue(vehicleCreateBulkInput);

      return axiosClient<void>(
      {url: `/vehicles/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleCreateBulkInput, signal
    },
      );
    }




export const getCreateBulkVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkVehicle>>, TError,{data: VehicleCreateBulkInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createBulkVehicle>>, TError,{data: VehicleCreateBulkInput}, TContext> => {

const mutationKey = ['createBulkVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkVehicle>>, {data: VehicleCreateBulkInput}> = (props) => {
          const {data} = props ?? {};

          return  createBulkVehicle(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkVehicle>>>
    export type CreateBulkVehicleMutationBody = VehicleCreateBulkInput
    export type CreateBulkVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create multiple vehicles
 */
export const useCreateBulkVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkVehicle>>, TError,{data: VehicleCreateBulkInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createBulkVehicle>>,
        TError,
        {data: VehicleCreateBulkInput},
        TContext
      > => {
      return useMutation(getCreateBulkVehicleMutationOptions(options), queryClient);
    }
    /**
 * @summary Update multiple vehicles
 */
export const updateBulkVehicle = (
    vehicleUpdateBulkInput: MaybeRefOrGetter<VehicleUpdateBulkInput>,
 signal?: AbortSignal
) => {
      vehicleUpdateBulkInput = toValue(vehicleUpdateBulkInput);

      return axiosClient<void>(
      {url: `/vehicles/bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleUpdateBulkInput, signal
    },
      );
    }




export const getUpdateBulkVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBulkVehicle>>, TError,{data: VehicleUpdateBulkInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateBulkVehicle>>, TError,{data: VehicleUpdateBulkInput}, TContext> => {

const mutationKey = ['updateBulkVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBulkVehicle>>, {data: VehicleUpdateBulkInput}> = (props) => {
          const {data} = props ?? {};

          return  updateBulkVehicle(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBulkVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof updateBulkVehicle>>>
    export type UpdateBulkVehicleMutationBody = VehicleUpdateBulkInput
    export type UpdateBulkVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update multiple vehicles
 */
export const useUpdateBulkVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBulkVehicle>>, TError,{data: VehicleUpdateBulkInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateBulkVehicle>>,
        TError,
        {data: VehicleUpdateBulkInput},
        TContext
      > => {
      return useMutation(getUpdateBulkVehicleMutationOptions(options), queryClient);
    }
    /**
 * @summary Check Vehicle Serial
 */
export const checkSerialVehicle = (
    checkInput: MaybeRefOrGetter<CheckInput>,
 signal?: AbortSignal
) => {
      checkInput = toValue(checkInput);

      return axiosClient<Check>(
      {url: `/vehicles/check-serial`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkInput, signal
    },
      );
    }




export const getCheckSerialVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSerialVehicle>>, TError,{data: CheckInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkSerialVehicle>>, TError,{data: CheckInput}, TContext> => {

const mutationKey = ['checkSerialVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkSerialVehicle>>, {data: CheckInput}> = (props) => {
          const {data} = props ?? {};

          return  checkSerialVehicle(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckSerialVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof checkSerialVehicle>>>
    export type CheckSerialVehicleMutationBody = CheckInput
    export type CheckSerialVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Check Vehicle Serial
 */
export const useCheckSerialVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSerialVehicle>>, TError,{data: CheckInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof checkSerialVehicle>>,
        TError,
        {data: CheckInput},
        TContext
      > => {
      return useMutation(getCheckSerialVehicleMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete all ingame bought Vehicles
 */
export const destroyAllIngameVehicles = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/vehicles/destroy-all-ingame`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAllIngameVehiclesMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllIngameVehicles>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAllIngameVehicles>>, TError,void, TContext> => {

const mutationKey = ['destroyAllIngameVehicles'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAllIngameVehicles>>, void> = () => {


          return  destroyAllIngameVehicles()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAllIngameVehiclesMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAllIngameVehicles>>>

    export type DestroyAllIngameVehiclesMutationError = ErrorType<StandardError>

    /**
 * @summary Delete all ingame bought Vehicles
 */
export const useDestroyAllIngameVehicles = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllIngameVehicles>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAllIngameVehicles>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyAllIngameVehiclesMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy multiple Vehicles
 */
export const destroyBulkVehicle = (
    vehicleDestroyBulkInput: MaybeRefOrGetter<VehicleDestroyBulkInput>,
 signal?: AbortSignal
) => {
      vehicleDestroyBulkInput = toValue(vehicleDestroyBulkInput);

      return axiosClient<void>(
      {url: `/vehicles/destroy-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleDestroyBulkInput, signal
    },
      );
    }




export const getDestroyBulkVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkVehicle>>, TError,{data: VehicleDestroyBulkInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyBulkVehicle>>, TError,{data: VehicleDestroyBulkInput}, TContext> => {

const mutationKey = ['destroyBulkVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyBulkVehicle>>, {data: VehicleDestroyBulkInput}> = (props) => {
          const {data} = props ?? {};

          return  destroyBulkVehicle(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyBulkVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof destroyBulkVehicle>>>
    export type DestroyBulkVehicleMutationBody = VehicleDestroyBulkInput
    export type DestroyBulkVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy multiple Vehicles
 */
export const useDestroyBulkVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkVehicle>>, TError,{data: VehicleDestroyBulkInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyBulkVehicle>>,
        TError,
        {data: VehicleDestroyBulkInput},
        TContext
      > => {
      return useMutation(getDestroyBulkVehicleMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Vehicle
 */
export const destroyVehicle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Vehicle>(
      {url: `/vehicles/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicle>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVehicle>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVehicle>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyVehicle(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVehicle>>>

    export type DestroyVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Delete Vehicle
 */
export const useDestroyVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicle>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVehicle>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyVehicleMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Vehicle
 */
export const showVehicle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Vehicle>(
      {url: `/vehicles/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowVehicleQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',id
    ] as const;
    }


export const getShowVehicleQueryOptions = <TData = Awaited<ReturnType<typeof showVehicle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showVehicle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowVehicleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showVehicle>>> = ({ signal }) => showVehicle(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showVehicle>>, TError, TData>
}

export type ShowVehicleQueryResult = NonNullable<Awaited<ReturnType<typeof showVehicle>>>
export type ShowVehicleQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Vehicle
 */

export function useShowVehicle<TData = Awaited<ReturnType<typeof showVehicle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowVehicleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Vehicle
 */
export const updateVehicle = (
    id: MaybeRefOrGetter<string>,
    vehicleUpdateInput: MaybeRefOrGetter<VehicleUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
vehicleUpdateInput = toValue(vehicleUpdateInput);

      return axiosClient<Vehicle>(
      {url: `/vehicles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleUpdateInput, signal
    },
      );
    }




export const getUpdateVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,{id: string;data: VehicleUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,{id: string;data: VehicleUpdateInput}, TContext> => {

const mutationKey = ['updateVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicle>>, {id: string;data: VehicleUpdateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVehicle(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicle>>>
    export type UpdateVehicleMutationBody = VehicleUpdateInput
    export type UpdateVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Vehicle
 */
export const useUpdateVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,{id: string;data: VehicleUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVehicle>>,
        TError,
        {id: string;data: VehicleUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateVehicleMutationOptions(options), queryClient);
    }
